/**
 * @file The UI name of one derived value's shape — the five names the Derived
 * values list shows, derived from the entry and never stored, so a config written
 * by any surface reads the same. Consumer: the Derived values list's Kind column;
 * the drawer's source-kind segmented control reads `formDeriveCopy` directly.
 * Four of the five names ARE that deck's `sourceKindOption` and are read from it,
 * so the list and the control cannot word one shape two ways. The fifth is the
 * list's own: the deck calls a copied field "Another field", which answers where
 * the value comes from, while the Kind column says what the derived value does.
 * Invariants: `FormDeriveEntry` has no top-level discriminant, so the algebraic
 * arm is recognized by `'operands' in entry` and the row projection by
 * `'columns' in entry`, both BEFORE `entry.source.kind`, which narrows
 * `entry.source` alone; a projection's `colUniques` source is unreachable in the
 * switch for exactly that reason. The word "formula" never appears here: that is
 * the ArTable mechanism, not this one.
 */
import { formDeriveCopy } from './formDeriveCopy';
import type { FormDeriveEntry } from '#types';

function formDeriveKindLabel(entry: FormDeriveEntry): string {
  const { sourceKindOption } = formDeriveCopy;
  if ('operands' in entry) return sourceKindOption.calculation;
  if ('columns' in entry) return sourceKindOption.projection;
  switch (entry.source.kind) {
    case 'field':
      return 'Copy a field';
    case 'colAggregate':
      return sourceKindOption.colAggregate;
    case 'referenceProp':
      return sourceKindOption.referenceProp;
  }
}

export { formDeriveKindLabel };
